import { until } from '@vueuse/core';
import type { Ref } from 'vue';
import { mount } from 'mount-vue-component';
import GlobalCropper from '@apps/admin/layouts/components/GlobalCropper.vue';
import type { GroupImageDisplayModel, SubjectImageDisplayModel } from '@shared/models/subjects/images';
import type { ICropCoords } from '@shared/models/crop';
import type { MCropperResult } from './models';

export function useCropper() {
  const crop = async (
    image: Partial<SubjectImageDisplayModel | GroupImageDisplayModel>,
    aspectRatio: number,
    softCrop?: ICropCoords,
  ) => {
    const elGlob = document.getElementById('global-croppers');
    const div = document.createElement('div');
    elGlob?.appendChild(div);

    // Mount the GlobalCropper component
    const { vNode, destroy, el } = mount(GlobalCropper, {
      props: { src: image.imageThumbnailUrl, aspectRatio, crop: softCrop, rotation: image.rotation ?? 0 },
      element: div,
    });

    const exposed = vNode.component?.proxy?.$.exposed;

    const ready = exposed?.ready as Ref<boolean>;
    const getResult = exposed?.getResult as () => MCropperResult | null;

    await until(ready).toBe(true);

    return new Promise<MCropperResult | null>((resolve, reject) => {
      const result = getResult();
      //TODO: Destroy is causing the cropper to throw an error

      div.remove();
      //destroy();

      resolve(result);
    });
  };

  return {
    softCropImage: crop,
  };
}

function useImageTester() {
  const getDimensions = async (files: File[]) => {
    if (files[0]) {
      const originalUrl = URL.createObjectURL(files[0]);

      const onload = new Promise<HTMLImageElement>((resolve, reject) => {
        const image = new Image();
        image.src = originalUrl;
        image.addEventListener('load', () => {
          URL.revokeObjectURL(originalUrl);
          resolve(image);
        });
        image.addEventListener('error', (event) => {
          URL.revokeObjectURL(originalUrl);
          reject(event.error || new Error('Could not create thumbnail'));
        });
      });

      await Promise.all([onload]).then(([image]) => {
        const x = getProportionalDimensions(image, true);
        const y = getProportionalDimensions(image, false);
      });
    }
  };
  const getProportionalDimensions = (img: HTMLImageElement, bad: boolean) => {
    // eslint-disable-line no-shadow
    //const aspect = img.width / img.height;
    const aspect = bad ? img.height / img.width : img.width / img.height;
    return {
      width: 400,
      height: Math.round(400 / aspect),
    };
  };

  return {
    getDimensions,
  };
}
